import { APP_CONTAINER } from 'constants/global-constants';
import { events } from '@ddc-webplatform/cmsc-modules';

export const APP_ROOT = document.getElementById(APP_CONTAINER);

export const fireCloseEvent = () => {
	const el = document.getElementById(APP_CONTAINER);
	if (el) {
		events.dispatchAppEvent(APP_CONTAINER, 'editor-cancel');
	}
};
